/**
 * @generated SignedSource<<17b66fa9e152b6b93d1093e03d430389>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductOrder_memberPackage$data = {
  readonly customer: {
    readonly id: string;
  };
  readonly id: string;
  readonly package: {
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageSummary_package" | "usePackageDisplayName_package">;
  };
  readonly squareCard: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentMethod_squareCardOnFile">;
  } | null | undefined;
  readonly " $fragmentType": "StoreProductOrder_memberPackage";
};
export type StoreProductOrder_memberPackage$key = {
  readonly " $data"?: StoreProductOrder_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrder_memberPackage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductOrder_memberPackage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "squareCard",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentMethod_squareCardOnFile"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePackageDisplayName_package"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StorePackageSummary_package"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};
})();

(node as any).hash = "2f273b0cd4facd13fdb1bd5af54264ac";

export default node;
